module.exports = __webpack_public_path__ + "static/media/gb.d3ddd602.svg";